import listSaga from './list/list.saga';

export default [
    ...listSaga
];
